import React, { Component } from "react";
import { Marker, Popup } from "react-leaflet";
import { MapConstants } from "./constants";
import ReviewAverageComponent from "./review-average-component";
import { getListingImage } from "../../constants/util";

const defaultMarker = L.divIcon(MapConstants.defaultMarker);
class MapListingMarker extends Component {
  constructor(props) {
    super(props);
  }

  handleMarkerClick = (id) => {
    if (this.props.onMarkerClick) {
      this.props.onMarkerClick(id);
    }
  };

  render() {
    let { listing, dates, onPopupClose } = this.props;
    let l = listing;
    let url = `/app/#/listing/${l._id}`;
    url =
      dates && dates.from && dates.to
        ? url +
          `?start=${new Date(dates.from).toISOString()}&end=${new Date(
            dates.to
          ).toISOString()}`
        : url; /* ` for Chrome dubuggin purposes */
    return (
      <Marker
        key={l._id}
        id={l._id}
        position={[l.geometry.coordinates[1], l.geometry.coordinates[0]]}
        riseOnHover
        icon={defaultMarker}
        onClick={() => this.handleMarkerClick(l._id)}
      >
        <Popup className="listing-popup" minWidth="250" onClose={onPopupClose}>
          <a href={url}>
            <div className="row">
              {l.photos.length > 0 && (
                <div className="col image-container">
                  <div
                    style={{ backgroundImage: `url(${getListingImage(l)})` }}
                  />
                </div>
              )}
            </div>
            <div className="row">
              <div className="col">
                <span className="price-bold">${(Math.round(l.pricing.baseFee))}</span>{" "}
                avg/night
              </div>
              <div className="col m-auto">
                <div className="float-right">
                  <ReviewAverageComponent reviews={l.reviews} starsOnly />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col listing-name">{l.listingName}</div>
            </div>
            <div className="row">
              <div className="col listing-details">
                <span className="details">{l.houseType}</span> | {l.bedrooms}{" "}
                {l.bedrooms.count > 1 ? "bedrooms" : "bedroom"}
              </div>
            </div>
          </a>
        </Popup>
      </Marker>
    );
  }
}

export default MapListingMarker;
